module.exports = require("@swa-ui/core/src/Accordion/Accordion.module.scss");